import React, { useState } from "react"
import { Link as RouterLink } from "react-router-dom"
import { Menu, MenuItem, IconButton } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSquareRss } from "@fortawesome/pro-regular-svg-icons"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import type { TranslationKey } from "../../../../localization/translations"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { MERCHANT_CANTEEN_WEEK_MENU_ROUTE } from "../../../../../constants/routes"
import { fetchMenusList, MenuPlaningQuery, MenusListResponse } from "../menuPlanningApi"

const selectExternalFeeds = (data: MenusListResponse) => {
    return data?.menuPlanning?.externalFeeds
}

type WeekMenuAction = Readonly<{
    translationId: TranslationKey
    label: string
    onClick: () => void
}>

export function WeekMenuButton() {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
    const { merchantId } = useMerchant()

    const menuPlanningResult = useApiQuery(fetchMenusList, {
        queryName: MenuPlaningQuery.LIST,
        dependencies: {
            merchantId,
        },
        select: selectExternalFeeds,
    })

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const openFeed = (type: "RSS" | "ATOM") => {
        const feed = menuPlanningResult?.data?.find((feed) => feed.type === type)
        if (feed?.url) {
            window.open(feed.url, "_blank")
        } else {
            console.error(`No URL found for ${type} feed`)
        }
    }

    const feedActions: ReadonlyArray<WeekMenuAction> = [
        {
            translationId: "merchant-menu-planning-table-week-menu-rss-button",
            label: "Week menu as RSS",
            onClick: () => openFeed("RSS"),
        },
        {
            translationId: "merchant-menu-planning-table-week-menu-atom-button",
            label: "Week menu as Atom",
            onClick: () => openFeed("ATOM"),
        },
    ]

    return (
        <>
            <IconButton onClick={(e) => handleMenuOpen(e)}>
                <FontAwesomeIcon icon={faSquareRss} color="black" size="xl" />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                {feedActions.map(({ translationId, label, onClick }) => (
                    <LocalizedStrict key={translationId} id={translationId}>
                        <MenuItem
                            onClick={() => {
                                onClick()
                                handleMenuClose()
                            }}
                        >
                            {label}
                        </MenuItem>
                    </LocalizedStrict>
                ))}
                <LocalizedStrict id="merchant-menu-planning-table-week-menu-page-button">
                    <MenuItem component={RouterLink} to={MERCHANT_CANTEEN_WEEK_MENU_ROUTE} onClick={handleMenuClose}>
                        Week menu as web page
                    </MenuItem>
                </LocalizedStrict>
            </Menu>
        </>
    )
}
